import keyMirror from 'keymirror';

export const quizEditorActionTypes = keyMirror({
	GET_QUIZ_QUESTIONS_PANEL: null,
	GET_QUIZ_QUESTIONS_PANEL_SUCCESS: null,
	GET_QUIZ_QUESTIONS_PANEL_ERROR: null,
	CHANGE_QUESTION_POSITION: null,
	UPDATE_QUIZ_QUESTIONS_LIST: null,
	CREATE_QUIZ_QUESTION_REQUEST: null,
	CREATE_QUIZ_QUESTION_SUCCESS: null,
	CREATE_QUIZ_QUESTION_ERROR: null,
	GET_QUIZ_QUESTION_REQUEST: null,
	GET_QUIZ_QUESTION_SUCCESS: null,
	GET_QUIZ_QUESTION_ERROR: null,
	MANAGE_QUIZ_QUESTION_REQUEST: null,
	MANAGE_QUIZ_QUESTION_SUCCESS: null,
	MANAGE_QUIZ_QUESTION_ERROR: null,
	UPDATE_QUIZ_QUESTION_REQUEST: null,
	UPDATE_QUIZ_QUESTION_SUCCESS: null,
	UPDATE_QUIZ_QUESTION_ERROR: null,
	PREVIEW_QUIZ_REQUEST: null,
	PREVIEW_QUIZ_SUCCESS: null,
	PUBLISH_QUIZ_REQUEST: null,
	PUBLISH_QUIZ_SUCCESS: null,
	PUBLISH_QUIZ_ERROR: null,
	SELECT_QUIZ_QUESTION: null,
	SET_QUIZ_PANEL_STREAM: null,
	SET_QUIZ_UPDATE_TIME: null,
	CHANGE_QUESTION_DATA_PROGRESS: null,
	CLEAR_QUIZ_EDITOR: null,
});

export const removeIdsFromList = (data) => {
	return data.map((item) => {
		const formattedItem = { ...item };
		delete formattedItem.id;
		return formattedItem;
	});
};

export const removeIdsFromObject = (data) => {
	const formattedData = { ...data };
	if (formattedData.answer_variations && formattedData.answer_variations.length) {
		formattedData.answer_variations = removeIdsFromList(formattedData.answer_variations);
	}
	delete formattedData.id;
	return formattedData;
};

export const formatDataForCompare = (data) => {
	const formattedData = { ...data };
	formattedData.answer_variations_attributes = formattedData.answer_variations;
	delete formattedData.answer_variations;
	delete formattedData.question_part;
	delete formattedData.id;
	formattedData.answer_variations_attributes = formattedData.answer_variations_attributes.map(
		(el) => ({ answer_text: el.answer_text }),
	);
	return formattedData;
};

export const UPDATE_DELAY = 1000;

export const QUIZ_TYPES = {
	topic: 'topic',
	diagnostic_1: 'diagnostic_1',
	diagnostic_2: 'diagnostic_2',
	user_quiz: 'user_quiz',
	exam: 'exam',
	practice_set: 'practice-set',
};

export const getStageByType = (type) => {
	switch (type) {
		case 'topic':
			return 'topic';
		case 'diagnostic_1':
			return 'diagnostic_1';
		case 'diagnostic_2':
			return 'diagnostic_2';
		case 'exam':
			return 'full_exam';
		case 'practice-set':
			return 'exam_practice_set';
		default:
			return 'user_quiz';
	}
};

export const getQuizUrl = (id, type, questionId, tab) => {
	const { topic, diagnostic_1, diagnostic_2, exam, practice_set } = QUIZ_TYPES;
	switch (type) {
		case topic:
		case diagnostic_1:
		case diagnostic_2:
			return `/topics/${id}/quiz/${type}${questionId ? `/${questionId}` : ''}${
				tab ? `/${tab}` : ''
			}`;
		case exam:
		case practice_set:
			return `/quizzes/${type}/${id}/quiz${questionId ? `/${questionId}` : ''}${
				tab ? `/${tab}` : ''
			}`;
		default:
			return `/edit-quiz/${id}${questionId ? `/${questionId}` : ''}`;
	}
};

export const removeWrapParagraphTags = (str = '') => {
	if (/^<p>.*<\/p>$/.test(str)) {
		return str.slice(3, -4);
	}
	return str;
};
